module.exports = __webpack_public_path__ + "img/injiring.0524474c.svg";